import styled, { css } from 'styled-components'
import Anchor from '@/ui/Anchor'

export const CheckAnchor = styled(Anchor)`
  ${({ theme, disabled }) => css`
    display: block;
    cursor: ${!disabled ? 'pointer' : 'default'};
    color: ${theme.primaryColor};
  `}
`
